import { Menu } from "lucide-react";

import { useAuth } from "@/lib/auth";

interface TopbarProps {
  pageTitle?: string;
  /** Open the mobile navigation drawer (shown only on narrow viewports). */
  onOpenMobileNav?: () => void;
}

export function Topbar({ pageTitle = "", onOpenMobileNav }: TopbarProps) {
  const { user, logout } = useAuth();

  return (
    <header className="topbar">
      <div className="flex items-center gap-2 px-4">
        <button
          type="button"
          className="btn ghost icon sm sidebar-toggle-mobile"
          aria-label="Open navigation"
          onClick={onOpenMobileNav}
        >
          <Menu />
        </button>
        <span className="text-sm text-muted-foreground">
          {user?.organizationSlug ?? "default-org"}
        </span>
        {pageTitle && (
          <>
            <span className="text-muted-foreground">/</span>
            <span className="text-sm font-medium">{pageTitle}</span>
          </>
        )}
      </div>
      <div className="ml-auto flex items-center gap-2 px-4">
        {user && <span className="text-sm text-fg-2">{user.email}</span>}
        {/* Explicit "Sign out": no reason → the real OIDC flow does the
            RP-Initiated fleet-wide logout redirect. (W1) */}
        <button type="button" className="btn ghost sm" onClick={() => logout()}>
          Sign out
        </button>
      </div>
    </header>
  );
}
